export const REVIEW_ENTRIES_TOGGLEABLE_COLUMNS = [
  { id: 'status', labelKey: 'review_entries.table.column.status' },
  { id: 'date', labelKey: 'review_entries.table.column.date' },
  { id: 'supplierName', labelKey: 'review_entries.table.column.supplier' },
  { id: 'description', labelKey: 'review_entries.table.column.description' },
  { id: 'account', labelKey: 'review_entries.table.column.account' },
  { id: 'amountExclVat', labelKey: 'review_entries.table.column.excl_vat' },
  { id: 'vatRate', labelKey: 'review_entries.table.column.vat_rate' },
  { id: 'vatAmount', labelKey: 'review_entries.table.column.vat' },
  { id: 'amountInclVat', labelKey: 'review_entries.table.column.incl_vat' },
] as const

export type ReviewEntriesToggleableColumnId = (typeof REVIEW_ENTRIES_TOGGLEABLE_COLUMNS)[number]['id']
